<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved 
-->
<template>
  <div>
    <a v-if="isRadisson" class="logoTurismo" :href="safetyProtocolLogoHref" target="_blank"></a>
    <!-- layout 1-2-2 -->
    <b-container v-if="shouldRenderLayout1_2_2" fluid class='no-margin no-padding gallery-image-container c5'>
      <b-row no-gutters>
        <b-col cols="6">
          <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': firstImageThumb === null}">
                 <b-img @click="openGallery(0)" :src="firstImageThumb" :blank="firstImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
          </b-container>      
        </b-col>
        <b-col cols="6">
           <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': secondImageThumb === null}">
                <b-img @click="openGallery(1)" :src="secondImageThumb" :blank="secondImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': thirdImageThumb === null}">
                <b-img @click="openGallery(2)" :src="thirdImageThumb" :blank="thirdImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': fourthImageThumb === null}">
                <b-img @click="openGallery(3)" :src="fourthImageThumb" :blank="fourthImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': fifthImageThumb === null}">
                <b-img @click="openGallery(4)" :src="fifthImageThumb" :blank="fifthImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
           </b-container>
        </b-col>
      </b-row>
    </b-container>

    <!-- layout 1-2-1 -->
    <b-container v-if="shouldRenderLayout1_2_1" fluid class='no-margin no-padding gallery-image-container c4'>
      <b-row no-gutters>
        <b-col cols="6">
          <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': firstImageThumb === null}">
                 <b-img @click="openGallery(0)" :src="firstImageThumb" :blank="firstImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
          </b-container>      
        </b-col>
        <b-col cols="6">
           <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': secondImageThumb === null}">
                <b-img @click="openGallery(1)" :src="secondImageThumb" :blank="secondImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
              <b-col cols="6" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': thirdImageThumb === null}">
                <b-img @click="openGallery(2)" :src="thirdImageThumb" :blank="thirdImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="12" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': fourthImageThumb === null}">
                <b-img @click="openGallery(3)" :src="fourthImageThumb" :blank="fourthImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
           </b-container>
        </b-col>
      </b-row>
    </b-container>

    <!-- layout 1-1-1 -->
    <b-container v-if="shouldRenderLayout1_1_1" fluid class='no-margin no-padding gallery-image-container c3'>
      <b-row no-gutters>
        <b-col cols="8">
          <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': firstImageThumb === null}">
                 <b-img @click="openGallery(0)" :src="firstImageThumb" :blank="firstImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
          </b-container>      
        </b-col>
        <b-col cols="4">
           <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col cols="12" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': secondImageThumb === null}">
                <b-img @click="openGallery(1)" :src="secondImageThumb" :blank="secondImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="12" class="gallery-item gallery-item-small img-hover-zoom light-border" :class="{ 'skeleton-box': thirdImageThumb === null}">
                <b-img @click="openGallery(2)" :src="thirdImageThumb" :blank="thirdImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
           </b-container>
        </b-col>
      </b-row>
    </b-container>

    <!-- layout 1-1 -->
    <b-container v-if="shouldRenderLayout1_1" fluid class='no-margin no-padding gallery-image-container c5'>
      <b-row no-gutters>
        <b-col cols="6">
          <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': firstImageThumb === null}">
                 <b-img @click="openGallery(0)" :src="firstImageThumb" :blank="firstImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
          </b-container>      
        </b-col>
        <b-col cols="6">
           <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': secondImageThumb === null}">
                <b-img @click="openGallery(1)" :src="secondImageThumb" :blank="secondImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
           </b-container>
        </b-col>
      </b-row>
    </b-container>

    <!-- layout 1 -->
    <b-container v-if="shouldRenderLayout1" fluid class='no-margin no-padding gallery-image-container c2'>
      <b-row no-gutters>
        <b-col cols="12">
          <b-container fluid class='no-margin no-padding'>
            <b-row no-gutters>
              <b-col class="gallery-item gallery-item-big img-hover-zoom light-border" :class="{ 'skeleton-box': firstImageThumb === null}">
                 <b-img @click="openGallery(0)" :src="firstImageThumb" :blank="firstImageThumb === null ? true : false"  alt="Fluid-grow image" class="full-container-width-height"></b-img>
              </b-col>
            </b-row>
          </b-container>      
        </b-col>
      </b-row>
    </b-container>

    <MPGalleryButtons
      v-collision="['groupone']"
      @non-collide="nonCollideHandler"
    />
    <lightbox
      :images="allImages"
      ref="lightbox"
      :showLightBox="false"
      :show-caption="false"
    ></lightbox>
  </div>
</template>

<script>
import MPGalleryButtons from './GalleryButtons'
import Lightbox from 'vue-image-lightbox'

export default {
  name: 'MPHero',
  components: {
    MPGalleryButtons,
    Lightbox
  },

  data() {
    return {
      baseUrl: '',
      baseStyles: [],
      noImage: false
    }
  },
  computed: {
    bgimage: function() {
      if (this.$store.state.getImages.length > 0) {
        this.noImage = false
        return this.$store.state.getImages[0]
      } else {
        this.noImage = true
        return true
      }
    },
    isRegus: function() {
      return this.$store.state.isRegus
    },
    allImages: function(){
      if(this.$store.state.getImages.length > 0){    
        return this.$store.state.getImages.map(image => ({
          thumb:image,
          src: image
        }))
      }
      return []
    },
    firstImageThumb: function(){
      if(this.allImages.length > 0){
        return this.allImages[0].thumb;
      }
      return null
    },
    secondImageThumb: function(){
      if(this.allImages.length > 1){
        return this.allImages[1].thumb;
      }
      return null
    },
    thirdImageThumb: function(){
      if(this.allImages.length > 2){
        return this.allImages[2].thumb;
      }
      return null
    },
    fourthImageThumb: function(){
      if(this.allImages.length > 3){
        return this.allImages[3].thumb;
      }
      return null
    },
    fifthImageThumb: function(){
      if(this.allImages.length > 4){
        return this.allImages[4].thumb;
      }
      return null
    },

    shouldRenderLayout1_2_2: function(){   
      return (this.allImages.length === 0 || this.allImages.length >=5) && this.windowWidth >= 1140
    },
    shouldRenderLayout1_2_1: function(){   
      return (this.allImages.length === 4 &&  this.windowWidth >= 1140)
      //  || ((this.allImages.length === 0 || this.allImages.length >= 4) && (this.windowWidth >= 960 && this.windowWidth < 1280))
    },
    shouldRenderLayout1_1_1: function(){   
      return (this.allImages.length === 3 && this.windowWidth >= 734) || ((this.allImages.length === 0 || this.allImages.length >= 3) && (this.windowWidth >= 734 && this.windowWidth < 1140))
    },
    shouldRenderLayout1_1: function(){   
      return (this.allImages.length === 2 && this.windowWidth >= 734)
    },
    shouldRenderLayout1: function(){   
      return (this.allImages.length > 0 && this.allImages.length < 2) || ((this.allImages.length === 0 || this.allImages.length >= 1) && this.windowWidth < 734)
    },
    language: function() {
      return this.$store.state.selectedLang
    },
    isRadisson(){
        return window.isRadisson == '1' ? true : false
    },
    safetyProtocolLogoHref(){
      let returnHref = ''
      switch (this.language) {
        case 'en':
          returnHref = 'https://www.radissonhotels.com/en-us/social-responsibility/health-safety'
          break
        case 'sv':
          returnHref = 'https://www.radissonhotels.com/sv-se/socialt-ansvar/halsa-sakerhet'
          break
        case 'sv':
          returnHref = 'https://www.radissonhotels.com/nl-nl/gezondheid-veiligheid'
          break
        default: 
          returnHref = 'https://www.radissonhotels.com/en-us/social-responsibility/health-safety'
          break
      }
      return returnHref
    }
     
  },
  methods: {
    nonCollideHandler(collider) {
      // logic for 'window' group, called when the component does NOT collide with window
      this.stickyObject = {
        position: 'initial',
        width: '336.66px',
        top: '121px'
      }
    },
    openGallery: function(index) {
      if (this.allImages.length >= (index - 1)) {
        this.$refs.lightbox.showImage(index)
      }
    },
  }
}
</script>

<style scope>
.dark-border {
  border: 1px solid #000;
}
.light-border {
  border: 1px solid #fff;
}
.gallery-item {
  cursor: pointer;
}
.gallery-item-big {
  height: 240px;
}
.gallery-item-small {
  height: 120px;
}
.no-margin {
  margin: 0 !important;
}
.no-padding {
  padding: 0 !important;
}
.full-container-width-height {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-hover-zoom {
  overflow: hidden;
}

.img-hover-zoom img {
  transition: transform .45s cubic-bezier(0.645, 0.045, 0.355, 1) 0s, filter .45s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
}

.img-hover-zoom:hover img {
  transform: scale(1.05);
}

.gallery-image-container:hover .img-hover-zoom:not(:hover) img {
  filter: brightness(0.7);
}

@media (min-width: 639px){
  .gallery-item-big {
    height: 55vh;
  }

  .gallery-item-small {
    height: 27.5vh;
  }
}

@keyframes skeleton {
  0%   {background-color:#c9c9c9;}
  25%  {background-color:#c2c2c2;}
  50%  {background-color:#bbb;}
  75%  {background-color:#b0b0b0;}
  100% {background-color:#a3a3a3;}
}

.skeleton-box {
  animation: skeleton 1.2s linear 0.1s infinite alternate;
}

.sectionWithBackgroundContainer {
  width: 80vw;
}
.vue-lb-info {
  padding-top: 7px;
}
.logoTurismo {
    position: absolute;
    right: 20px;
    top: 15px;
    width: 140px;
    height: 140px;
    display: block;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: url(https://d1whte2dpudn87.cloudfront.net/dd9f75dd1e76139ebc7bef4fa5329a3b_368_368.png) no-repeat center center;
    background-size: contain;
    z-index: 1;
}
@media (max-width: 576px) {
  .logoTurismo {
    width: 90px;
    height: 90px;
  }
}
</style>
